import { render, staticRenderFns } from "./parkDetail.vue?vue&type=template&id=248685f6&scoped=true"
import script from "./parkDetail.vue?vue&type=script&lang=js"
export * from "./parkDetail.vue?vue&type=script&lang=js"
import style0 from "./parkDetail.vue?vue&type=style&index=0&id=248685f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248685f6",
  null
  
)

export default component.exports